import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import TimeTable from '../time-table/TimeTable';
import { toTimeRows } from '../time-table/timeTableSlice';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { SerializedError } from '../../util/types';
import Metadata from '../metadata/Metadata';
import MDViewer from '../markdown/Markdown';
import {
  Ticket,
  selectTicket,
  selectChildrenItems,
} from './ticketSlice';
import { useTicketViewQuery, TicketItemsResponse } from '../../api/ticket';
import TicketDisplay from './TicketDisplay';
import { ToolBar } from './RightToolBar';

const vcontentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	display: 'flex',
	//backgroundColor: 'pink',
};
const contentStyle = {
	height: '100%',
	width: '100%',
	margin: 0,
	//overflow: 'auto',
	display: 'flex',
	//backgroundColor: 'grey',
};
const colOneStyle = {
	height: '100%',
	flexGrow: 4,
	width: '50%',
	//backgroundColor: '#eeeeee',
	//overflow: 'auto',
};
const colTwoStyle = {
	height: '100%',
	flexGrow: 4,
	//backgroundColor: 'green',
	width: '50%',
	//overflow: 'auto',
};
const viewStyle = {
	height: `calc(100% - 44px)`,
	overflow: 'auto',
	padding: 2,
	width: '100%',
	//height: '100%r',
	//backgroundColor: 'purple',
};

export default function TicketPaneViewer({id}: {id: string | undefined | null}) {

	const idv = id ? id : null;
	const idStr = id ? id : "";
	const ticket = useAppSelector(selectTicket(idStr));
	const {
		//data: TicketItemsResponse,
		data,
		isLoading,
		isFetching,
		isSuccess,
		isError,
		error
	} = useTicketViewQuery(idStr, { refetchOnMountOrArgChange: true});
	let content: React.ReactNode

	if (isLoading) {
		content = <TicketViewerLoading />
	} else if (isFetching) {
		content = <TicketViewerFetching />
	} else if (isSuccess) {
		content = <TicketViewerSuccess ticket={ticket}/>
	} else if (isError) {
		content = <TicketViewerError error={error} />
	}
	return (
		<Box>
			{
				content
			}
		</Box>
	);
}

/*
interface QueryProps {
	id: string | null;
	data: TicketItemsResponse;
	isLoading: boolean;
	isFetching: boolean;
	isSuccess: boolean;
	isError: boolean;
	error: FetchBaseQueryError | SerializedError | undefined;
};

export function TicketViewerLeft({
	id,
	data,
	isLoading,
	isFetching,
	isSuccess,
	isError,
	error
}: QueryProps) {
}
// */

export function TicketViewerLoading() {
	return (
		<Box>
			Loading
		</Box>
	);
}

export function TicketViewerFetching() {
	return (
		<Box>
			Fetching
		</Box>
	);
}

export function TicketViewerError({error}:
								  {error: FetchBaseQueryError | SerializedError | undefined }) {
	return (
		<Box>
			Error
		</Box>
	);
}

export function TicketViewerSuccess({ticket}: {ticket: Ticket | null}) {
	if (ticket) {
		return (<TicketDisplay ticket={ticket} />);
	} else {
		return (<Box> Nothing </Box>)
	}
}

/*
export function TicketViewerPane({ticket}: {ticket: Ticket}) {
	return (
		<Box>
			<Typography variant="title">{ticket.title}</Typography>
			<Metadata meta={ticket.metadata}/>
			<MDViewer md={ticket.content.content} />
		</Box>
	);
}
// */
